import { render } from "./Effect_information.vue?vue&type=template&id=47abebea"
import script from "./Effect_information.vue?vue&type=script&lang=js"
export * from "./Effect_information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__